import ReservedCollectionButtonToggle from './ReservedCollectionButtonToggle.vue'

export { ReservedCollectionButtonToggle }
export default ReservedCollectionButtonToggle
